<template>
  <div class="ml">
    <!-- Dil secici dropdown (sag ust, sayfa uzerinde) -->
    <div v-if="!isNativeMobile" class="ml-lang-dropdown" v-click-outside="closeLangDropdown">
      <button type="button" class="ml-lang-dropdown__trigger" @click="langDropdownOpen = !langDropdownOpen">
        <img :src="currentLanguageFlag" alt="" class="ml-lang-dropdown__flag" />
        <i class="icon-feather-chevron-down ml-lang-dropdown__arrow" :class="{ 'ml-lang-dropdown__arrow--open': langDropdownOpen }"></i>
      </button>
      <transition name="ml-lang-fade">
        <div v-if="langDropdownOpen" class="ml-lang-dropdown__menu">
          <button v-for="(item, i) in languages" :key="i"
                  v-show="item.lang !== activeLanguage" type="button" class="ml-lang-dropdown__item"
                  @click="selectLang(item.lang)" :data-lang="item.lang">
            <img :src="item.flag" alt="" class="ml-lang-dropdown__item-flag" />
            <span>{{ item.name }}</span>
          </button>
        </div>
      </transition>
    </div>

    <div class="ml-wrapper">

      <!-- ===== SOL: Brand Panel (desktop'ta görünür) ===== -->
      <div v-if="!isNativeMobile" class="ml-side" :class="{ 'ml-side--has-image': hasLoginImage }">
        <!-- Login image varsa -->
        <img v-if="hasLoginImage" :src="loginImageSrc" alt="" class="ml-side__banner" />
        <!-- Yoksa gradient + logo -->
        <div v-else class="ml-side__inner">
          <div v-if="company && company.logo_link" class="ml-side__logo-wrap">
            <img :src="company.logo_link" alt="" class="ml-side__logo" />
          </div>
          <h1 v-if="company" class="ml-side__title">{{ company.name }}</h1>
          <p class="ml-side__desc">{{ $t("login.header_text") }}</p>
        </div>
      </div>

      <!-- ===== SAĞ: Form Panel ===== -->
      <div class="ml-main">
        <div class="ml-main__inner">

          <!-- Mobil: brand üstte (mobil + responsive, desktop'ta gizli) -->
          <div class="ml-brand-mobile">
            <div v-if="company && company.logo_link" class="ml-brand-mobile__avatar">
              <img :src="company.logo_link" alt="" class="ml-brand-mobile__img" />
            </div>
            <div v-if="company" class="ml-brand-mobile__name">{{ company.name }}</div>
            <div class="ml-brand-mobile__desc">{{ $t("login.header_text") }}</div>
          </div>

          <!-- Card -->
          <div class="ml-card">
            <!-- Register link -->
            <div v-if="!isNativeMobile && company && company.is_allowed_register_user" class="ml-register">
              <a href="javascript:void(0)" class="ml-register__link" @click="$router.push({ name: 'index.register' })">
                <i class="icon-feather-user-plus"></i> {{ $t("general.Sing_In") }}
              </a>
            </div>

            <form @submit.prevent="onSubmit()" autocomplete="off">

              <!-- Login type -->
              <div v-if="!isMetroCompany" class="ml-group ml-group--select">
                <label class="ml-label">{{ $t("profile.login_type") }}</label>
                <multiple-select-input
                  :model.sync="selectedLoginType"
                  :values="loginTypeOptions"
                  :show-labels="false"
                  :allow-empty="false"
                  :disabled="!isLoginTypeChangeAllowed"
                  label="translatedName"
                  track-by="type"
                  :searchable="false"
                  name="login_type"
                />
              </div>

              <!-- Username -->
              <div class="ml-group">
                <label class="ml-label">{{ $t(form.username) }}</label>
                <div class="ml-input-wrap">
                  <i class="icon-feather-user ml-input-wrap__pre"></i>
                  <input v-model="form.email" type="text" class="ml-input"
                         :placeholder="form.placeholder && $t(form.placeholder)" autocomplete="username" />
                </div>
              </div>

              <!-- Password -->
              <div class="ml-group">
                <label class="ml-label">{{ $t("general.password") }}</label>
                <div class="ml-input-wrap">
                  <i class="icon-feather-lock ml-input-wrap__pre"></i>
                  <input v-model="form.password" :type="passwordType ? 'text' : 'password'"
                         class="ml-input ml-input--has-suffix" autocomplete="current-password" />
                  <button type="button" class="ml-input-wrap__eye" @click="showPassword('passwordType')">
                    <i :class="passwordType ? 'icon-feather-eye-off' : 'icon-feather-eye'"></i>
                  </button>
                </div>
              </div>

              <!-- Error -->
              <div v-if="errors || errorMessage" class="ml-alert">
                <i class="uil-exclamation-triangle ml-alert__icon"></i>
                <span class="ml-alert__text">{{ errors || errorMessage }}</span>
              </div>

              <!-- Actions -->
              <div class="ml-actions">
                <button type="button" class="ml-link" @click="$router.push({ name: 'index.forgot-password' })">
                  {{ $t("login.forgot_password") }}
                </button>
                <button type="submit" class="ml-btn" :disabled="is_button">
                  <span v-if="is_button" uk-spinner="ratio: 0.45"></span>
                  <span v-else>{{ $t("login.header") }}</span>
                </button>
              </div>

              <!-- SSO -->
              <button v-if="sso_login" type="button" class="ml-sso" @click="onSsoLogin">
                {{ $t("general.sso_login") }}
              </button>

            </form>
          </div>


        </div>
      </div>

    </div>

    <!-- Powered by logo -->
    <div v-if="!isNativeMobile" class="ml-powered">
      <BrandSignature
        :src="loginLogoFooter"
        logo-height="20px"
        logo-class="ml-powered__img"
        size="small"
        theme="muted"
      />
    </div>
  </div>
</template>

<script>
import { GET_ITEM_DETAIL_BY_ID as COMPANY_DETAIL } from "@/core/services/store/REST.module";
import { ERROR, LOGIN, PURGE_AUTH, SET_ERROR, } from "@/core/services/store/auth.module";
import { validationMixin } from "vuelidate";
import store from "@/core/services";
import SecureLS from "secure-ls";
import axios from "axios";
import i18nService from "@/core/services/i18n.service.js";
import { getCachedTranslations } from "@/core/services/i18n.Api.Service";
import bridge from "@/core/services/bridge.service";
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput.vue";
import BrandSignature from "@/view/layouts/shared/components/BrandSignature.vue";
// import { VueRecaptcha } from "vue-recaptcha";

const ls = new SecureLS({ encodingType: "aes", isCompression: true });
import company_module, {
  GET_SELF as COMPANY_GET_SELF,
  MODULE_NAME as COMPANY_MODULE_NAME,
  SELF_URL as COMPANY_SELF_URL,
} from "@/core/services/store/company.module";
import { subCompany, getSubCompanyId, getInitialSubDomainId, } from "@/core/services/store.js";
import { getAlias } from "@/utils/urlHelper";

function getCachedCompanyInfo() {
  try {
    const cached = JSON.parse(localStorage.getItem("app_company_info"));
    if (cached && cached.name) return cached;
  } catch (_) {}
  return null;
}

function getSavedLanguage() {
  try {
    return ls.get("language") || "";
  } catch (_) {
    return "";
  }
}

export default {
  name: "AuthLayout",
  mixins: [validationMixin],
  directives: {
    'click-outside': {
      bind(el, binding) {
        el._clickOutside = (e) => {
          if (!el.contains(e.target)) binding.value();
        };
        document.addEventListener('click', el._clickOutside);
      },
      unbind(el) {
        document.removeEventListener('click', el._clickOutside);
      },
    },
  },
  components: { BrandSignature, MultipleSelectInput },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(COMPANY_MODULE_NAME, company_module);

    // Cache varsa API beklemeden hemen göster
    try {
      const cached = JSON.parse(localStorage.getItem("app_company_info"));
      if (cached && cached.name) {
        this.company = cached;
        this.sso_login = cached.sso_login || null;
        this.is_loading = false;
      }
    } catch (_) {}

    // API'den arka planda güncelle
    const self = this;
    this.$store
        .dispatch(COMPANY_DETAIL, {
          url: "api/company/info",
          filters: { alias: getAlias() },
        })
        .then((result) => {
          this.is_loading = false;
          if (result.status) {
            const pureData = JSON.parse(JSON.stringify(result.data));
            if (Object.keys(pureData).length === 0) {
              this.$router.push({ path: "/404" });
              return;
            }

            self.company = result.data;
            self.sso_login = result.data.sso_login || null;
            self.applyCompanyLanguage(result.data?.language?.language);
            // Mobil'den login_field gelmediyse veya giriş yöntemi değiştirilemiyorsa şirket varsayılanını uygula
            if (!this.$route.query.login_field || !this.isLoginTypeChangeAllowed) {
              this.setLoginTypeById(result.data.login_type_id);
            }

            // Cache'i güncelle — sonraki açılışlarda anında gösterilsin
            try {
              localStorage.setItem("app_company_info", JSON.stringify(result.data));
            } catch (_) {}
          } else {
            this.$router.push({ path: "/404" });
          }
        })
        .catch(() => {
          this.is_loading = false;
        });
  },
  mounted() {
    const savedLanguage = getSavedLanguage();
    if (savedLanguage && this.$i18n) {
      this.$i18n.locale = savedLanguage;
    } else {
      this.applyCompanyLanguage(this.company?.language?.language);
    }

    // Cache'deki login_type_id'yi uygula (mobil'den login_field gelmediyse veya giriş yöntemi değiştirilemiyorsa)
    if (!this.$route.query.login_field || !this.isLoginTypeChangeAllowed) {
      try {
        const cached = JSON.parse(localStorage.getItem("app_company_info"));
        if (cached && cached.login_type_id) {
          this.setLoginTypeById(cached.login_type_id);
        }
      } catch (_) {}
    }

    this.getLanguagesMapping();
    // this.getLoginTypes();
    this.subdomain = window.location.hostname;

    // Mobil WebView'dan gelen email ve login_field parametresini doldur
    if (this.$route.query.email) {
      this.form.email = this.$route.query.email;
    }
    if (this.$route.query.login_field && this.isLoginTypeChangeAllowed) {
      const lt = this.login_types.find(item => item.type === this.$route.query.login_field);
      if (lt) {
        this.form.login_field = lt.type;
        this.form.username = lt.username;
        this.form.placeholder = lt.placeholder || "";
      }
    }
    let url = window.location.href;
    if (url.includes("www.")) {
      this.company = {
        logo_link: "/media/images/anzera-logo-medium.png",
        name: "Anzera Öğrenme Teknolojileri A.Ş.",
        type: "Dijital Öğrenme Platformu",
        is_allowed_register_user: 0,
      };
    }

    this.$store.commit(SET_ERROR, "");
    let version = process.env.VUE_APP_VERSION;
    let localVersion = ls.get("version");
    if (!localVersion || version !== localVersion) {
      // window.localStorage.clear();
      ls.set("version", version);
      // location.reload();
    }
  },
  data() {
    return {
      isNativeMobile: !!window.ReactNativeWebView,
      subCompany: subCompany,
      languages: i18nService.languages,
      languagesMapping: [],
      subdomain: "",
      login_types: [
        {
          id: 1,
          name: "general.login_with_email",
          type: "email",
          icon: "uil-envelope",
          username: "login.email_label",
        },
        {
          id: 2,
          name: "general.login_with_phone_number",
          type: "phone",
          icon: "uil-phone",
          username: "login.phone_label",
          placeholder: "login.phone_placeholder",
        },
        {
          id: 3,
          name: "general.login_with_id_number",
          type: "national_id",
          icon: "uil-postcard",
          username: "login.national_label",
        },
        {
          id: 4,
          name: "general.login_with_registration_number",
          type: "registration_number",
          icon: "uil-keyboard",
          username: "login.registration_label",
        },
      ],
      errorMessage: "",
      is_loading: true,
      form: {
        email: "",
        password: "",
        login_field: "email",
        username: "login.email_label",
        // recaptcha: "",
      },
      company: getCachedCompanyInfo(),
      sso_login: (getCachedCompanyInfo() || {}).sso_login || null,
      passwordType: false,
      is_button: false,
      langDropdownOpen: false,
      userLanguageApplied: false,
      // sitekey: process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY,
    };
  },
  computed: {
    isMetroCompany() {
      try {
        const cached = JSON.parse(localStorage.getItem("app_company_info"));
        return cached?.alias === "akademi" && window.location.host === "akademi.metro.istanbul";
      } catch (_) {
        return false;
      }
    },
    hasLoginImage() {
      return !!this.loginImageSrc;
    },
    loginImageSrc() {
      const images = this.company?.login_images || {};
      if (!Object.keys(images).length) {
        return "";
      }

      return (
        images[this.activeLanguage] ||
        images.tr ||
        Object.values(images).find(Boolean) ||
        ""
      );
    },
    isLoginTypeChangeAllowed() {
      const allowed = this.company?.is_allowed_login_type;
      return allowed === undefined || allowed === null || !!Number(allowed);
    },
    loginTypeOptions() {
      const types = this.isLoginTypeChangeAllowed
        ? this.login_types
        : this.login_types.filter(item => item.id === this.company?.login_type_id);
      // Şirketin login_type_id'si listede yoksa setLoginTypeById ile aynı şekilde email'e düş
      const options = types.length ? types : this.login_types.filter(item => item.type === "email");

      return options.map(item => ({
        ...item,
        translatedName: this.$t(item.name),
      }));
    },
    selectedLoginType: {
      get() {
        return this.loginTypeOptions.find(item => item.type === this.form.login_field) || this.loginTypeOptions[0];
      },
      set(val) {
        if (val) {
          this.form.login_field = val.type;
          this.changeUsername(val.type);
        }
      },
    },
    activeLanguage() {
      return getSavedLanguage() || this.company?.language?.language || "tr";
    },
    currentLanguageFlag() {
      const language = this.languages.find((val) => val.lang === this.activeLanguage);
      return language ? language.flag : this.languages[0]?.flag || "";
    },
    loginLogoFooter() {
      return process.env.BASE_URL + "media/images/logo-dark.svg";
    },
    errors() {
      return store.getters[ERROR];
    },
    loginLogo() {
      return process.env.BASE_URL + "assets/media/logos/logo-letter-13.png";
    },
    backgroundImage() {
      return process.env.BASE_URL + "media/bg/bg-3.jpg";
    },
  },
  methods: {
    async ensureLanguagesMapping() {
      if (this.languagesMapping.length) {
        return this.languagesMapping;
      }

      // 1) localStorage i18n_translations_cache_v* (main.js ile aynı) — languages burada
      const cached = getCachedTranslations();
      if (cached && Array.isArray(cached.languages) && cached.languages.length) {
        this.languagesMapping = cached.languages;
        return this.languagesMapping;
      }

      // 2) Cache yoksa tek seferlik API
      try {
        const result = await axios.get("api/localization", { headers: this.apiHeaders });
        this.languagesMapping = result?.data?.languages || [];
      } catch {
      }

      return this.languagesMapping;
    },
    setLoginTypeById(id) {
      const selected = this.login_types.find(item => item.id === id);
      if (selected) {
        this.form.login_field = selected.type;
        this.form.username = selected.username;
        this.form.placeholder = selected.placeholder || "";
      } else {
        const def = this.login_types.find(item => item.type === "email");
        this.form.login_field = def.type;
        this.form.username = def.username;
        this.form.placeholder = def.placeholder || "";
      }
    },
    mergeUniquePermissions(roles) {
      const permissionMap = new Map();

      roles.forEach((role) => {
        if (roles.length > 1 && role.name === "user") {
          return;
        }
        role?.permissions?.forEach((permission) => {
          if (!permissionMap.has(permission.name)) {
            permissionMap.set(permission.name, permission);
          }
        });
      });
      return Array.from(permissionMap.values());
    },
    applyThemeSettings(theme = {}) {
      const root = document.documentElement;
      root.style.setProperty("--iconColor", theme.iconColor || "#93949c");
      root.style.setProperty(
          "--backgroundColor",
          theme.backgroundColor || "#666CFF"
      );
    },
    selectedLanguage(e) {
      if (e) {
        const el = e.target.closest("[data-lang]");
        const lang = el.getAttribute("data-lang");
        i18nService.setActiveLanguage(lang);
        this.$emit(
            "language-changed",
            this.languages.find((val) => {
              return val.lang === lang;
            })
        );
        window.location.reload();
      }
    },
    isActiveLanguage(current) {
      return this.activeLanguage === current;
    },
    closeLangDropdown() {
      this.langDropdownOpen = false;
    },
    selectLang(lang) {
      this.langDropdownOpen = false;
      i18nService.setActiveLanguage(lang);
      this.$emit("language-changed", this.languages.find((val) => val.lang === lang));
      window.location.reload();
    },
    changeUsername(type) {
      const selected = this.login_types.find(item => item.type === type);

      if (selected) {
        this.form.username = selected.username;
        this.form.placeholder = selected.placeholder || "";
      }
    },

    showPassword(element) {
      switch (element) {
        case "passwordType":
          this.passwordType = !this[element];
          break;
        case "confirmPasswordType":
          this.confirmPasswordType = !this[element];
          break;
      }
    },

    async getCompanyItem() {
      const isNativeMobile = !!window.ReactNativeWebView;
      try {
        const response = await this.$store.dispatch(
            COMPANY_MODULE_NAME + "/" + COMPANY_GET_SELF,
            {
              url: COMPANY_SELF_URL,
            }
        );
        const parentCompany = JSON.parse(ls.get("parentCompany") || "{}");
        subCompany.value = response.children || [];
        if (parentCompany?.company_name && parentCompany?.company_id) {
          subCompany.value.unshift({
            name: parentCompany.company_name,
            id: parentCompany.company_id,
          });
        }

        const selfLanguageId =
            response?.user?.language_id ||
            response?.user?.language?.id;
        if (selfLanguageId) {
          await this.setLanguageByUserId(selfLanguageId);
        }
        if (!this.userLanguageApplied) {
          this.applySavedUserLanguage();
        }

        getSubCompanyId.value = getInitialSubDomainId();
        const settings = response?.settings?.find(
            (x) => x.key === "theme_settings"
        );
        this.applyThemeSettings(settings?.value);
        if (!this.company?.logo_link && this.company?.name) {
          document.title = this.company.name;
        }
        // Mobil: admin paneli yok, varsayılan her zaman user dashboard. Deep link ile
        // gelindiyse (redirect_url) hedef sayfaya gidilir; admin sayfaları atlanır.
        // Web: admin kontrolü ve redirect desteği.
        const defaultPath = !isNativeMobile && this.isAdmin ? "/admin/dashboard" : "/dashboard";
        const redirectUrl = window.localStorage.getItem("redirect_url");
        window.localStorage.removeItem("redirect_url");

        if (redirectUrl && redirectUrl !== "undefined" && redirectUrl !== "null") {
          const cleanRedirectUrl = redirectUrl.replace(/^#/, '');
          const resolved = this.$router.resolve(cleanRedirectUrl);
          if (resolved?.resolved?.matched?.length > 0) {
            const isAdminPage = cleanRedirectUrl.startsWith("/admin");
            const canOpenAdminPage = !isNativeMobile && this.isAdmin;
            await this.$router.push({ path: (isAdminPage && !canOpenAdminPage) ? defaultPath : cleanRedirectUrl });
          } else {
            await this.$router.push({ path: defaultPath });
          }
        } else {
          await this.$router.push({ path: defaultPath });
        }
      } catch (error) {
        if (!this.userLanguageApplied) {
          this.applySavedUserLanguage();
        }
        const fallbackPath = isNativeMobile ? "/dashboard" : (this.isAdmin ? "/admin/dashboard" : "/dashboard");
        this.$router.push({ path: fallbackPath }).catch(() => {});
      }
    },
    async onSubmit() {
      let redirectUrl = this.$route.query.redirect;
      if (redirectUrl && typeof redirectUrl !== "undefined") {
        window.localStorage.setItem("redirect_url", redirectUrl);
      }

      const username = this.form.email;
      const password = this.form.password;
      const login_field = this.form.login_field;
      // const recaptcha = this.form.recaptcha;

      if (username.length < 3) {
        this.errorMessage = this.$t("validation.required_field").replace(
            ":NAME",
            this.$t("general.username")
        );
        return false;
      }

      if (password.length < 3) {
        this.errorMessage = this.$t("validation.required_field").replace(
            ":NAME",
            this.$t("general.password")
        );
        return false;
      }

      // set spinner to submit button
      this.is_button = true;
      // clear existing errors
      this.$store.commit(SET_ERROR, null);
      const alias = getAlias();
      // send login request
      this.$store
          .dispatch(LOGIN, { username, password, alias, login_field })
          .then(async (response) => {
            // this.onCaptchaExpired();
            if (response?.data?.roles) {
              const mergedPermissions = this.mergeUniquePermissions(response.data.roles);
              ls.set("permissions", mergedPermissions);
              ls.set("roleCount", response.data.roles.length);
            }
            if (response.status === 200) {
              // Native app'e login bilgisi gönder

              bridge.send('LOGIN_SUCCESS', {
                token: response.data.access_token,
                subdomain: response.data.company_name || '',
                userId: response.data.id,
                name: response.data.name || '',
                email: response.data.email || '',
              });

              if (response?.data?.language_id) {
                await this.setLanguageByUserId(response.data.language_id);
              }
              await this.getCompanyItem();
            } else {
              this.is_button = false;
              this.$router.push({
                name: "index.confirm-access-code",
                params: {
                  user: {
                    username,
                    password,
                    login_field,
                    // recaptcha: recaptcha,
                  },
                },
              });
            }
          })
          .catch(() => {
            this.is_button = false;
          });
    },
    onSsoLogin() {
      if (this.sso_login) {
        window.location.href = this.sso_login;
      }
    },
    async getLanguagesMapping() {
      await this.ensureLanguagesMapping();
    },
    applyCompanyLanguage(lang) {
      if (getSavedLanguage() || this.userLanguageApplied || !lang || !this.$i18n) return;
      this.$i18n.locale = lang;
    },
    applySavedUserLanguage() {
      if (this.userLanguageApplied) return;

      const saved = getSavedLanguage();
      if (!saved) return;

      this.userLanguageApplied = true;
      if (this.$i18n && this.$i18n.locale !== saved) {
        this.$i18n.locale = saved;
      }
      window.dispatchEvent(new CustomEvent("app-language-changed", { detail: { lang: saved } }));
    },
    async setLanguageByUserId(languageId) {
      if (!languageId) {
        return;
      }

      await this.ensureLanguagesMapping();
      if (!this.languagesMapping.length) {
        return;
      }

      const normalizedLanguageId = Number(languageId);
      const language = this.languagesMapping.find((lang) => Number(lang.id) === normalizedLanguageId);
      const languageCode = language?.code || language?.language || language?.lang;
      if (!languageCode) {
        return;
      }

      this.userLanguageApplied = true;
      i18nService.setActiveLanguage(languageCode);
      if (this.$i18n && this.$i18n.locale !== languageCode) {
        this.$i18n.locale = languageCode;
      }
      window.dispatchEvent(new CustomEvent("app-language-changed", { detail: { lang: languageCode } }));
    },
  },
  watch: {
    errors(val) {
      if (val) this.is_loading = false;
    },
  },
};
</script>

<style scoped>
/* ═══════════════════════════════════════
   LOGIN — Layout shell
   ═══════════════════════════════════════ */
.ml {
  position: fixed;
  inset: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  background: #f7f8fc;
  z-index: 100;
}

.ml-wrapper {
  display: flex;
  min-height: 100vh;
  min-height: 100dvh;
}

/* ═══════════════════════════════════════
   SOL PANEL — Brand / Logo
   ═══════════════════════════════════════ */
.ml-side {
  display: none; /* mobilde gizli */
}

.ml-side__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px;
}

.ml-side__logo-wrap {
  width: 96px;
  height: 96px;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  overflow: hidden;
}

.ml-side__logo {
  width: 64px;
  height: 64px;
  object-fit: contain;
}

.ml-side__title {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 8px;
  line-height: 1.3;
  letter-spacing: -0.01em;
}

.ml-side__desc {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.75);
  margin: 0;
  line-height: 1.5;
  max-width: 280px;
}

/* ═══════════════════════════════════════
   SAĞ PANEL — Form
   ═══════════════════════════════════════ */
.ml-main {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px 32px;
}

.ml-main__inner {
  width: 100%;
  max-width: 420px;
}

/* ─── Mobil brand (üstte, desktop'ta gizli) ─── */
.ml-brand-mobile {
  text-align: center;
  margin-bottom: 24px;
  padding: 0 8px;
}

.ml-brand-mobile__avatar {
  width: 72px;
  height: 72px;
  margin: 0 auto 14px;
  border-radius: 16px;
  background: #fff;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.06),
    0 8px 24px rgba(102, 108, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.ml-brand-mobile__img {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.ml-brand-mobile__name {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  line-height: 1.3;
}

.ml-brand-mobile__desc {
  font-size: 13px;
  color: #6b7280;
  margin-top: 4px;
  line-height: 1.4;
}

/* ═══════════════════════════════════════
   CARD
   ═══════════════════════════════════════ */
.ml-card {
  width: 100%;
  background: #fff;
  border-radius: 14px;
  padding: 24px 20px;
  box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.04),
    0 4px 16px rgba(0, 0, 0, 0.04);
}

/* ─── Register link ─── */
.ml-register {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}

.ml-register__link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #666CFF;
  text-decoration: none;
  padding: 6px 14px;
  border: 1.5px solid #666CFF;
  border-radius: 8px;
  transition: background 0.15s ease;
}

.ml-register__link:hover {
  background: rgba(102, 108, 255, 0.06);
}

/* ─── Form group ─── */
.ml-group {
  margin-bottom: 18px;
}

.ml-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
  line-height: 1;
}

/* ─── Select (MultipleSelectInput) ─── */
.ml-group--select .form-group {
  margin-bottom: 0;
}
.ml-group--select .form-group > label {
  display: none;
}

/* ─── Input ─── */
.ml-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.ml-input-wrap__pre {
  position: absolute !important;
  left: 14px !important;
  top: 25% !important;
  font-size: 15px;
  color: #9ca3af;
  pointer-events: none;
  line-height: 1;
  margin: 0 !important;
  padding: 0 !important;
}

.ml-input {
  width: 100%;
  height: 46px;
  padding: 0 14px 0 40px;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  background: #f9fafb;
  font-size: 14px;
  font-family: inherit;
  color: #1f2937;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.ml-input--has-suffix {
  padding-right: 46px;
}

.ml-input:focus {
  border-color: #666CFF;
  box-shadow: 0 0 0 3px rgba(102, 108, 255, 0.1);
  background: #fff;
}

.ml-input::placeholder {
  color: #b0b5bf;
}

.ml-input-wrap__eye {
  position: absolute !important;
  right: 4px !important;
  top: 8% !important;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  border-radius: 8px;
  color: #9ca3af;
  font-size: 15px;
  cursor: pointer;
  padding: 0;
  transition: color 0.15s ease, background 0.15s ease;
}

.ml-input-wrap__eye:hover {
  color: #666CFF;
  background: #f3f4f6;
}

.ml-input-wrap__eye:active {
  background: #eef0f2;
  color: #666CFF;
}

/* ─── Error ─── */
.ml-alert {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 10px;
  margin-bottom: 18px;
}

.ml-alert__icon {
  font-size: 15px;
  color: #ef4444;
  flex-shrink: 0;
  margin-top: 1px;
}

.ml-alert__text {
  font-size: 13px;
  color: #b91c1c;
  line-height: 1.45;
}

/* ─── Actions row ─── */
.ml-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 4px;
}

.ml-link {
  background: none;
  border: none;
  padding: 0;
  font-size: 13px;
  font-weight: 500;
  color: #666CFF;
  cursor: pointer;
  line-height: 1;
  white-space: nowrap;
  flex-shrink: 0;
  transition: opacity 0.15s ease;
}

.ml-link:hover { opacity: 0.8; }
.ml-link:active { opacity: 0.6; }

.ml-btn {
  height: 44px;
  padding: 0 32px;
  border: none;
  border-radius: 10px;
  background: #666CFF;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 0.15s ease, transform 0.1s ease;
  -webkit-tap-highlight-color: transparent;
}

.ml-btn:hover { background: #5a5fe6; }
.ml-btn:active { transform: scale(0.97); background: #5258d4; }
.ml-btn:disabled { opacity: 0.6; pointer-events: none; }

/* ─── SSO ─── */
.ml-sso {
  width: 100%;
  height: 44px;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  color: #374151;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  margin-top: 14px;
  transition: border-color 0.15s ease, background 0.15s ease;
  -webkit-tap-highlight-color: transparent;
}

.ml-sso:hover { border-color: #d1d5db; background: #fafafa; }
.ml-sso:active { border-color: #666CFF; background: #f9fafb; }

/* ─── Powered by ─── */
.ml-powered {
  position: absolute;
  bottom: 16px;
  right: 16px;
  opacity: 0.78;
  transition: opacity 0.2s ease;
}

.ml-powered:hover {
  opacity: 1;
}

.ml-powered__img {
  height: 20px;
  width: auto;
}

/* ─── Language Dropdown ─── */
.ml-lang-dropdown {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 110;
}

.ml-lang-dropdown__trigger {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 6px 10px;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  -webkit-tap-highlight-color: transparent;
}

.ml-lang-dropdown__trigger:hover {
  border-color: #d1d5db;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.ml-lang-dropdown__flag {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  object-fit: cover;
}

.ml-lang-dropdown__arrow {
  font-size: 12px;
  color: #9ca3af;
  transition: transform 0.2s ease;
}

.ml-lang-dropdown__arrow--open {
  transform: rotate(180deg);
}

.ml-lang-dropdown__menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 160px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 4px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.08),
    0 1px 3px rgba(0, 0, 0, 0.04);
}

.ml-lang-dropdown__item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 12px;
  background: none;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-family: inherit;
  color: #374151;
  cursor: pointer;
  transition: background 0.12s ease;
  -webkit-tap-highlight-color: transparent;
}

.ml-lang-dropdown__item:hover {
  background: #f3f4f6;
}

.ml-lang-dropdown__item:active {
  background: #e5e7eb;
}

.ml-lang-dropdown__item-flag {
  width: 20px;
  height: 20px;
  border-radius: 3px;
  object-fit: cover;
  flex-shrink: 0;
}

/* Dropdown transition */
.ml-lang-fade-enter-active,
.ml-lang-fade-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.ml-lang-fade-enter,
.ml-lang-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

/* ═══════════════════════════════════════
   RESPONSIVE
   ═══════════════════════════════════════ */

/* Kisa ekranlar (iPhone SE vb.) */
@media (max-height: 640px) {
  .ml-main {
    padding-top: 24px;
    padding-bottom: 16px;
  }
  .ml-brand-mobile { margin-bottom: 20px; }
  .ml-brand-mobile__avatar { width: 56px; height: 56px; border-radius: 12px; margin-bottom: 10px; }
  .ml-brand-mobile__img { width: 36px; height: 36px; }
  .ml-brand-mobile__name { font-size: 16px; }
  .ml-group { margin-bottom: 14px; }
  .ml-card { padding: 20px 16px; }
}

/* ═══ DESKTOP (>= 960px): Ortalanmis kart, sol+sag yan yana ═══ */
@media (min-width: 960px) {
  .ml {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ml-wrapper {
    flex-direction: row;
    max-width: 900px;
    width: 100%;
    min-height: auto;
    border-radius: 16px;
    overflow: hidden;
    box-shadow:
      0 2px 8px rgba(0, 0, 0, 0.06),
      0 12px 48px rgba(0, 0, 0, 0.08);
  }

  /* Sol panel */
  .ml-side {
    display: flex;
    flex: 1 1 50%;
    min-height: 520px;
    align-items: center;
    justify-content: center;
    background: linear-gradient(145deg, #666CFF 0%, #5258d4 50%, #3d42a8 100%);
    position: relative;
    overflow: hidden;
  }

  /* Login image varsa */
  .ml-side--has-image {
    background: #fff;
    padding: 20px;
  }

  .ml-side__banner {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
  }

  /* Dekoratif daireler (sadece gradient modda) */
  .ml-side:not(.ml-side--has-image)::before,
  .ml-side:not(.ml-side--has-image)::after {
    content: '';
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.05);
  }
  .ml-side:not(.ml-side--has-image)::before {
    width: 300px;
    height: 300px;
    top: -80px;
    left: -60px;
  }
  .ml-side:not(.ml-side--has-image)::after {
    width: 200px;
    height: 200px;
    bottom: -40px;
    right: -40px;
  }

  .ml-side__inner {
    position: relative;
    z-index: 1;
  }

  /* Sag panel */
  .ml-main {
    flex: 1 1 50%;
    padding: 40px 36px;
    background: #fff;
  }

  .ml-main__inner {
    max-width: 100%;
  }

  /* Desktop'ta mobil brand gizle */
  .ml-brand-mobile {
    display: none;
  }

  /* Card — desktop'ta shadow yok, arka plan zaten beyaz */
  .ml-card {
    padding: 0;
    border-radius: 0;
    box-shadow: none;
    background: transparent;
  }

  .ml-group { margin-bottom: 20px; }

  .ml-input {
    height: 48px;
    font-size: 15px;
  }

  .ml-btn {
    height: 46px;
    font-size: 15px;
    padding: 0 36px;
  }

  .ml-sso {
    height: 46px;
    font-size: 15px;
  }

  .ml-label {
    font-size: 14px;
    margin-bottom: 8px;
  }

  .ml-link { font-size: 14px; }

  .ml-lang-dropdown {
    top: 24px;
    right: 24px;
  }

  .ml-powered {
    bottom: 24px;
    right: 24px;
  }
}

/* Genis desktop */
@media (min-width: 1200px) {
  .ml-wrapper {
    max-width: 1000px;
  }
  .ml-side__title { font-size: 26px; }
  .ml-side__logo-wrap {
    width: 104px;
    height: 104px;
    border-radius: 24px;
    margin-bottom: 28px;
  }
  .ml-side__logo {
    width: 72px;
    height: 72px;
  }
  .ml-main {
    padding: 48px 44px;
  }
}
</style>

<style>
/* MultipleSelectInput — login page overrides (unscoped) */
.ml-group--select .multiselect {
  position: relative !important;
  height: 46px !important;
  min-height: 46px !important;
  border: 1.5px solid #e5e7eb !important;
  border-radius: 10px !important;
  background: #f9fafb !important;
  font-size: 14px !important;
  font-family: inherit !important;
  cursor: pointer !important;
  overflow: visible !important;
  transition: border-color 0.15s ease, box-shadow 0.15s ease !important;
}

.ml-group--select .multiselect--active {
  border-color: #666CFF !important;
  box-shadow: 0 0 0 3px rgba(102, 108, 255, 0.1) !important;
  background: #fff !important;
}

.ml-group--select .multiselect__tags {
  min-height: 44px !important;
  padding: 0 40px 0 14px !important;
  border: none !important;
  border-radius: 10px !important;
  background: transparent !important;
  display: flex !important;
  align-items: center !important;
}

.ml-group--select .multiselect__single {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 14px !important;
  color: #1f2937 !important;
  line-height: 44px !important;
  background: transparent !important;
}

.ml-group--select .multiselect__select {
  position: absolute !important;
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  height: 100% !important;
  width: 36px !important;
  padding: 0 8px 0 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 46px !important;
}

.ml-group--select .multiselect__select::before {
  top: auto !important;
  border-color: #9ca3af transparent transparent !important;
}

.ml-group--select .multiselect__content-wrapper {
  max-height: none !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 10px !important;
  margin-top: 4px !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.04) !important;
  overflow: hidden !important;
}

.ml-group--select .multiselect__element + .multiselect__element {
  border-top: 1px solid #f3f4f6 !important;
}

.ml-group--select .multiselect__option {
  padding: 10px 14px !important;
  font-size: 14px !important;
  color: #374151 !important;
  min-height: auto !important;
  line-height: 1.4 !important;
  border-radius: 0 !important;
}

.ml-group--select .multiselect__element:first-child .multiselect__option {
  border-radius: 10px 10px 0 0 !important;
}

.ml-group--select .multiselect__element:last-child .multiselect__option {
  border-radius: 0 0 10px 10px !important;
}

.ml-group--select .multiselect__element:only-child .multiselect__option {
  border-radius: 10px !important;
}

.ml-group--select .multiselect__option--highlight {
  background: #f3f4f6 !important;
  color: #374151 !important;
}

.ml-group--select .multiselect__option--selected {
  background: rgba(102, 108, 255, 0.08) !important;
  color: #666CFF !important;
  font-weight: 600 !important;
}

.ml-group--select .multiselect__option--selected.multiselect__option--highlight {
  background: rgba(102, 108, 255, 0.12) !important;
  color: #666CFF !important;
}

.ml-group--select .multiselect__placeholder {
  color: #b0b5bf !important;
  font-size: 14px !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* Desktop size */
@media (min-width: 960px) {
  .ml-group--select .multiselect {
    height: 48px !important;
    min-height: 48px !important;
  }
  .ml-group--select .multiselect__tags {
    min-height: 46px !important;
  }
  .ml-group--select .multiselect__single {
    font-size: 15px !important;
    line-height: 46px !important;
  }
  .ml-group--select .multiselect__select {
    height: 46px !important;
  }
  .ml-group--select .multiselect__option {
    font-size: 15px !important;
  }
}
</style>
